import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { ZustandStoreWithDispatch } from '@modules/common/types';
import { Source } from 'generated/graphql';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { SearchAction, SearchState } from './store/types';

export interface SearchQuery {
  duration: DateTimeRange;
  whereClause: WhereClause | null;
}

export interface sourceChartDataPoint {
  id: Source;
  label: Source;
  value: number;
}

export enum INPUT_SEARCH_TYPE {
  'ADVANCED' = 'ADVANCED',
  'BASIC' = 'BASIC',
}

export type FeedStoreWithRedux = ZustandStoreWithDispatch<
  SearchState,
  SearchAction
>;
